import { type JSONState } from '#types/form/wizard.ts'

interface CheckIfCurrentStepHasChildren<T> {
	questionTree: JSONState<T>['questionTree']
	id: string
}

export function checkIfCurrentStepHasChildren<T>({
	questionTree,
	id,
}: CheckIfCurrentStepHasChildren<T>) {
	if (!questionTree) {
		throw new Error('questionTree is not defined')
	}

	if (!id) {
		throw new Error('id is not defined')
	}

	let currentNumber: number | undefined
	const [baseId, currentNumberStr] = id.split('-')

	if (currentNumberStr !== undefined) {
		currentNumber = parseInt(currentNumberStr, 10)
	}

	const children = questionTree
		.filter(treeItem => {
			if (treeItem.id.startsWith(baseId)) {
				if (currentNumber !== undefined) {
					const childNumber = parseInt(treeItem.id.split('-')[1], 10)
					return !isNaN(childNumber) && childNumber > currentNumber
				} else {
					return treeItem.id !== id
				}
			}
			return false
		})
		.map(treeItem => treeItem.id)

	return {
		hasChildren: children.length > 0,
		whichChildren: children.length > 0 ? children : undefined,
	}
}
